export default typeof window !== 'undefined' ? window.COMMON_CONFIG : (global as unknown as NodeJS.Global).COMMON_CONFIG
